import { render, staticRenderFns } from "./BbField.vue.html?vue&type=template&id=3a571885&"
import script from "./BbField.component.js?vue&type=script&lang=vueJs&"
export * from "./BbField.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BbField.global.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports